__turbopack_context__.v({
  "nextPanel": "next-panel-module__TtR9lq__nextPanel",
  "ruler": "next-panel-module__TtR9lq__ruler",
});
